import DisableGaModal from './DisableGaModal';

export default DisableGaModal;
